// extracted by mini-css-extract-plugin
export default {"sideBar":"side-bar_sideBar__3IElu"};